var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotVerifiedEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1862 -209)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 911",
    width: 28,
    height: 28,
    rx: 14,
    transform: "translate(1862 209)",
    fill: "#f73c3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.995 225.857a.82.82 0 01-.609-.246.836.836 0 01-.243-.611v-9.143a.827.827 0 01.248-.611.837.837 0 01.614-.246.82.82 0 01.609.246.836.836 0 01.243.611V225a.827.827 0 01-.248.611.837.837 0 01-.614.246zm0 5.143a.818.818 0 01-.609-.248.843.843 0 01-.243-.614.818.818 0 01.248-.609.843.843 0 01.614-.243.818.818 0 01.609.248.843.843 0 01.243.614.818.818 0 01-.248.609.843.843 0 01-.614.243z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
export default SvgNotVerifiedEmail;